import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { EmailValidator } from '@angular/forms';
import { text } from '@angular/core/src/render3/instructions';

/*
  Generated class for the SupportProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SupportProvider {
  collection: any;

  constructor(
    private afs: AngularFirestore
  )
  {
    // console.log('Hello CategoriesProvider Provider');
  }


  async getSupportMessages(){
    // console.log("getCategories");
    let data = [];
    if(this.collection== null)
      this.collection = await this.afs.firestore.collection("categories").orderBy('order');
    await this.collection.get().then(querySnapshot => {
      querySnapshot.docs.forEach(doc => {
        let object = doc.data();
        object.id = doc.id;
        data.push(object);
      });
    });
    // console.log("getCategories result",data);
    return data;
  }


  async sendSupportMessage(user, email,text) {
    // console.log("sendMessage event_id", event_id);
    // console.log("sendMessage uid", user_id);
    // console.log("sendMessage content", content);
    const data = {
      user:user,
      email:email,
      text:text,
      created_at: new Date().toISOString(),
    };
    // console.log("data", data);

    await this.afs
      .collection("support")
      .add(data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/support/support.ts